import { Box, Button, Text } from '@bonanza-social/moonlight';
import Config from '@bonanza-social/toolkit/config';
import Clipboard from '@react-native-clipboard/clipboard';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

const RESET_MS = 4000;

function LinkField({ referralCode }: { referralCode?: string }) {
  const [isCopied, setIsCopied] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const link = useMemo(
    () => (referralCode ? `${Config.PLATFORM_URL}/join/${referralCode}` : ''),
    [referralCode],
  );

  const onPress = useCallback(() => {
    if (!link || isCopied) return;

    Clipboard.setString(link);

    setIsCopied(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => setIsCopied(false), RESET_MS);
  }, [isCopied, link]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  return (
    <Box
      backgroundColor="secondaryBackgroundDefault"
      flexDirection="row"
      borderWidth="border-width-025"
      borderRadius="radius-200"
      padding="space-200"
      testID={`invite-friends-link-field`}
    >
      <Box flex={1}>
        <Button
          variant="primary"
          onPress={onPress}
          disabled={!link || isCopied}
          locNS="inviteFriends"
          locKey={isCopied ? 'unique_link_copied' : 'unique_link_button'}
          leftIcon={isCopied ? 'checkCircle' : 'link'}
        />
        <Text
          variant="caption"
          color="darkSurfaceMuted"
          marginTop="space-200"
          numberOfLines={1}
          alignSelf="center"
        >
          {link}
        </Text>
      </Box>
    </Box>
  );
}

export default LinkField;
